export default __webpack_public_path__ + "static/media/text-align-center.eb709ee9.svg";